<script lang="ts">
  export let movements: number;
  export let moveDirection: () => any;
  export let playerDidWin: () => void;

  const handleInputIn = () => {
    movements = window.setInterval(() => {
      moveDirection();
    }, 50);
  };

  const handleInputOut = () => {
    window.clearInterval(movements);
    playerDidWin;
  };
</script>

<button
  on:touchstart={handleInputIn}
  on:mousedown={handleInputIn}
  on:touchend={handleInputOut}
  on:mouseup={handleInputOut}
>
  <slot />
</button>

<style>
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 3px solid white;
    color: white;
    width: 100%;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }
</style>
